import { render, staticRenderFns } from "./Sibedar.vue?vue&type=template&id=7bb91da3&scoped=true&"
import script from "./Sibedar.vue?vue&type=script&lang=js&"
export * from "./Sibedar.vue?vue&type=script&lang=js&"
import style0 from "./Sibedar.vue?vue&type=style&index=0&id=7bb91da3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb91da3",
  null
  
)

export default component.exports